// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1RpXJ","sendOtp":"AuthorizeToLogin_sendOtp__VVFYW"};